import * as React from 'react';
import { Box, Button, ButtonGroup } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import CheckIcon from '@material-ui/icons/Check';
import { Tab } from '../../containers/NewDashboard/NewDashboardContainer';
import { fetchAllDataSharingConsent } from '../../slices/dataSharingConsent';
import { useAppDispatch, useTypedSelector } from '../../combineReducers';
import { useParams } from 'react-router-dom';
import { RouteParams } from 'aion-training-compliance-ui/src/features/operator/workGroupJobTypeContractor/containers/WorkGroupJobTypeContractorGeneralInfo';
import { useState } from 'react';

const useStyles = makeStyles(() =>
  createStyles({
    button: {
      borderColor: '#202020',
      color: '#202020',
      minWidth: 228,
      letterSpacing: 1
    },
    activeButton: {
      color: '#fff'
    }
  })
);

type Props = {
  tabs: Tab[];
  activeTab: string | null;
  onChange: (tab: string) => void;
};
export const DashboardTabs: React.FC<Props> = ({ tabs, activeTab, onChange }) => {
  const dispatch = useAppDispatch();
  const { organizationId } = useParams<RouteParams>();
  const classes = useStyles();
  const { dataSharingConsent } = useTypedSelector(state => state.dataSharingConsent);
  const [showConnectionsTab, setShowConnectionsTab] = useState(false);

  React.useEffect(() => {
    dispatch(fetchAllDataSharingConsent(organizationId));
  }, [dispatch, organizationId]);

  React.useEffect(() => {
    const hasDataSharing = dataSharingConsent.some(el => el.isDataSharing);
    setShowConnectionsTab(hasDataSharing);
  }, [dataSharingConsent]);

  return (
    <Box margin={2} display="flex" justifyContent="center">
      <ButtonGroup color="primary">
        {tabs.map(({ id, title }, index) => {
          if (title === 'Integrations' && !showConnectionsTab) {
            return null;
          }
          return (
            <Button
              key={id}
              onClick={() => onChange(id)}
              {...(activeTab === id || (!activeTab && index === 0)
                ? { startIcon: <CheckIcon />, variant: 'contained' }
                : {})}
              classes={{ root: classes.button, containedPrimary: classes.activeButton }}
            >
              {title}
            </Button>
          );
        })}
      </ButtonGroup>
    </Box>
  );
};
